import React from "react";
import { Dashboard } from "../components/dashboard";

function DashboardPage() {
  return (
    <div className="container-fluid relative mt-24 ml-10 mr-10">
      <Dashboard />;
    </div>
  );
}

export default DashboardPage;
